import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import Label from "../../form/Label";
import RadioGroupItem, { RadioGroup } from "../../form/Radio";
import Icon from "../../icons";
import cn from "../../utils/cn";
import Button from "../Button";
import Dropdown from "../Dropdown";
import Typography from "../Typography/Typography";
export default function Sort({ buttonTitle, title, options, defaultOption, onChange, placement, className }) {
    const [selected, setSelected] = useState(defaultOption);
    const [firstTime, setFirstTime] = useState(true);
    const handleChange = (value) => {
        const selectedByKey = options.find((option) => option.key === value);
        if (selectedByKey) {
            setSelected(selectedByKey);
            setFirstTime(false);
            onChange(selectedByKey);
        }
    };
    const getButtonTitle = () => {
        if (!buttonTitle)
            return null;
        if (firstTime) {
            return buttonTitle;
        }
        if (selected) {
            return selected.key;
        }
    };
    return (_jsx(_Fragment, { children: _jsx(Dropdown, { placement: placement, overlay: _jsxs(Dropdown.Overlay, { className: cn("w-full", className), children: [title && (_jsx(Dropdown.Header, { className: "px-2", children: _jsx(Typography, { variant: "description-title", className: "text-gray-dark", children: title }) })), _jsx(Dropdown.Body, { className: "mt-0.5 px-2", children: _jsx(RadioGroup, { defaultValue: defaultOption?.key, onValueChange: (value) => handleChange(value), children: options.map((option) => (_jsxs("div", { className: "flex items-center space-x-2", children: [_jsx(RadioGroupItem, { id: option.key, value: option.key }), _jsx(Label, { htmlFor: option.key, children: option.key })] }, option.key))) }) })] }), children: _jsxs(Button, { variant: "text", size: "condensed", children: [_jsx(Icon, { name: "cb-sort-menu-asc", className: "mr-2" }), getButtonTitle()] }) }) }));
}
